import React, { Fragment, useState } from 'react';
import {
    Stack,
    Container,
    Typography,
    Collapse,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    BottomNavigation,
    BottomNavigationAction,
    Paper,
    Box,
    Button,
    Modal,
    ImageList,
    ImageListItem
} from '@mui/material';
import TwitterIcon from '../../assets/icons/NavTwitterIcon';
import FacebookIcon from '../../assets/icons/NavFacebookIcon';
import InstagramIcon from '../../assets/icons/NavInstagramIcon';
import YoutubeIcon from '../../assets/icons/NavYoutubeIcon';
import TiktokIcon from '../../assets/icons/NavTiktokIcon';
import LinkedinIcon from '../../assets/icons/NavLinkedinIcon';
import GridTexture from '../../assets/Images/heroBackground.webp';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import SideMenuRightArrow from '../../assets/icons/SideMenuRightArrow';
import SideMenuArrowDown from '../../assets/icons/SideMenuArrowDown';
import ArrowDown from '../../assets/icons/ArrowDown';
import CloseIcon from '../../assets/icons/CloseIcon';
import logo from '../../assets/Images/logo.webp';

type MobileNavProps = {
    setMenu: any;
    menu: any;
};

const MobileNav = ({ setMenu, menu }: MobileNavProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showSubNav, setShowSubNav] = React.useState(false);
    const [activeMenu, setActiveMenu] = React.useState(null);
    // const handleCurrent = (name: string) => {
    //     if (name.length === 0) setCurrent(name);
    //     else setCurrent('');
    // };

    const handleClick = () => {
        // item.reff !== ''
        //     ? navigate(item?.ref ?? '')
        //     : e.preventDefault();
        // item.ref && item.ref.includes('http')
        //     ? navigate(item?.ref ?? '')
        //     : setShowSubNav(true);
        // setShowSubNav(!showSubNav);
    };

    const navLink = {
        fontWeight: 400,
        fontFamily: 'outfit',
        fontSize: '20px',
        transition: 'all .4s ease',
        '&:hover': {
            color: 'primary.main',
            fontWeight: 700
        }
    };

    const isActive = {
        color: 'primary.main',
        fontWeight: 700
    };

    const communityItems = [
        {
            name: 'LINKEDIN',
            icon: <LinkedinIcon />,
            ref: 'https://www.linkedin.com/company/job-factor/'
        },
        {
            name: 'TWITTER',
            icon: <TwitterIcon />,
            ref: 'https://twitter.com/_jobfactor'
        },
        {
            name: 'FACEBOOK',
            icon: <FacebookIcon />,
            ref: 'https://www.facebook.com/profile.php?id=100089853477839&mibextid=ZbWKwL'
        },
        {
            name: 'INSTAGRAM',
            icon: <InstagramIcon />,
            ref: 'https://www.instagram.com/officialjobfactor/'
        },
        {
            name: 'TIKTOK',
            icon: <TiktokIcon />,
            ref: 'https://www.tiktok.com/@officialjobfactor?_t=8aFd3ZWiKDF&_r=1'
        },
        {
            name: 'DISCORD',
            icon: ' ',
            ref: 'https://discord.com/channels/1191865612918591550/1191865612918591552'
        }
    ];

    const aboutItems = [
        { name: 'About Jobfactor', ref: '/about' },
        { name: 'How Jobfactor Works', ref: '/how-jobfactor-works' }
    ];

    const navItems = [
        { name: 'HOME', ref: '/' },
        {
            name: 'FIND A JOB',
            ref: '/create-account/professional'
        },
        {
            name: 'HIRE TALENT',
            ref: '/create-account/company'
        }
    ];

    const items = [
        {
            name: 'ABOUT US',
            ref: '/about',
            subNavItems: aboutItems
        },
        {
            name: 'COMMUNITY',
            subNavItems: communityItems
        }
    ];

    interface subNavProps {
        name: string;
        reff?: string;
        subNavItems: {
            name: string;
            ref: string;
            icon?: JSX.Element | React.ComponentType | any;
        }[];
    }

    const SubNav = ({ name, reff, subNavItems }: subNavProps) => {
        const [current, setCurrent] = useState('');
        const [open, setOpen] = useState(false);
        const navigate = useNavigate();

        return (
            <Box>
                <Container
                    disableGutters
                    sx={{
                        '&:hover': { cursor: 'pointer' },
                        zIndex: 3,
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        py: '12px',
                        borderBottom: '1px solid #AAAAAA'
                    }}
                >
                    <Box
                        width="100%"
                        onClick={() => {
                            setMenu(false);
                            reff && reff.includes('http')
                                ? navigate(reff ?? '')
                                : setShowSubNav(false);
                        }}
                    >
                        <Typography
                            color="navTextColor.main"
                            sx={
                                location.pathname === reff ||
                                location.pathname.includes(
                                    name.toLowerCase()
                                ) ||
                                current === name
                                    ? isActive
                                    : navLink
                            }
                        >
                            {name}
                        </Typography>
                    </Box>
                    <Box
                        zIndex={5}
                        onClick={() => {
                            if (current.length === 0) setCurrent(name);
                            else setCurrent('');
                            setOpen(!open);
                        }}
                    >
                        <ArrowDown open={!open} />
                    </Box>
                </Container>
                <Box sx={{ borderBottom: '1px solid #AAAAAA' }}>
                    {subNavItems.map((subItem) => (
                        <Collapse
                            in={open}
                            timeout="auto"
                            sx={{ width: '100%', zIndex: 5 }}
                        >
                            <List component="div" disablePadding>
                                {/* {subItem.name} */}
                                <ListItemButton
                                    sx={{
                                        py: '12px',
                                        px: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        zIndex: 5
                                    }}
                                    onClick={() => {
                                        // subItem.name ? navigate(item.location ?? '') : handleOpen()
                                        if (subItem.ref.includes('http'))
                                            window.open(subItem.ref, '_blank');
                                        else navigate(subItem.ref ?? '');
                                        setMenu(false);
                                    }}
                                >
                                    <Typography
                                        color="navTextColor.main"
                                        sx={
                                            location.pathname === subItem.ref ||
                                            location.pathname.includes(
                                                name.toLowerCase()
                                            )
                                                ? isActive
                                                : navLink
                                        }
                                    >
                                        {subItem?.name}
                                    </Typography>
                                    {subItem?.icon ? (
                                        <Box>{subItem?.icon}</Box>
                                    ) : null}
                                </ListItemButton>
                            </List>
                        </Collapse>
                    ))}
                </Box>
            </Box>
        );
    };

    return (
        <Modal open={menu} onClose={() => setMenu(false)}>
            <Stack
                data-aos="fade-down"
                sx={{
                    // pt: '30px',

                    zIndex: 20,
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    background: `linear-gradient(255deg, #f1fbff 0%, #fff3f5 100%)`,
                    overflow: 'auto'
                    // height: '100dvh'
                }}
            >
                <Stack>
                    <Stack
                        sx={{
                            zIndex: 3,
                            px: '16px',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: {
                                xs: 'space-between',
                                sm: 'flex-start',
                                lg: 'space-between'
                            },
                            height: { xs: '100px' },
                            pb: '0px'
                        }}
                    >
                        <ImageList
                            onClick={() => {
                                setMenu(false);
                                navigate('/');
                            }}
                            sx={{
                                transition: 'all .4s ease',
                                cursor: 'pointer',
                                '&:hover': {
                                    opacity: 0.8
                                }
                            }}
                            cols={1}
                        >
                            <ImageListItem>
                                <img src={logo} alt="logo" />
                            </ImageListItem>
                        </ImageList>
                        <Box onClick={() => setMenu(false)}>
                            <CloseIcon />
                        </Box>
                    </Stack>
                    <Stack sx={{ px: '16px' }}>
                        <Stack
                            sx={{
                                zIndex: 2,
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                overflow: 'hidden',
                                backgroundImage: `url(${GridTexture})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                            }}
                        ></Stack>
                        {navItems.map((item, index) => (
                            <Container
                                disableGutters
                                key={index}
                                sx={{
                                    '&:hover': { cursor: 'pointer' },
                                    zIndex: 3,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    py: '12px',
                                    borderBottom: '1px solid #AAAAAA'
                                }}
                            >
                                <Box
                                    height="100%"
                                    width="100%"
                                    onClick={() => {
                                        console.log({ index, item });
                                        setMenu(false);
                                        // navigate(item?.ref ?? item.href);

                                        if (item.ref.includes('http'))
                                            window.open(item.ref, '_blank');
                                        else navigate(item.ref ?? '');
                                    }}
                                >
                                    <Typography
                                        color="navTextColor.main"
                                        sx={
                                            location.pathname === item.ref ||
                                            location.pathname.includes(
                                                item.name.toLowerCase()
                                            )
                                                ? isActive
                                                : navLink
                                        }
                                    >
                                        {item?.name}
                                    </Typography>
                                </Box>
                            </Container>
                        ))}
                        {items.map((item) => (
                            <SubNav
                                name={item.name}
                                reff={item.ref}
                                subNavItems={item.subNavItems}
                            />
                        ))}
                    </Stack>
                </Stack>

                <Box
                    bottom={0}
                    right={0}
                    left={0}
                    p="12px 16px"
                    width="100%"
                    display="flex"
                    flexDirection="column"
                    justifyContent={'flex-end'}
                    gap="12px"
                    zIndex={6}
                    bgcolor="#fff"
                    sx={{
                        boxShadow: '0px -6px 10px 0px rgba(0, 0, 0, 0.2)',
                        position: 'sticky'
                    }}
                >
                    <Link
                        to="/create-account"
                        rel="noopener"
                        style={{ width: '100%' }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                width: '100%',
                                fontSize: '16px',
                                color: '#fff',
                                height: '40px',
                                borderRadius: '100px',
                                fontWeight: 600
                            }}
                        >
                            Sign Up
                        </Button>
                    </Link>
                    <Link to="/login" rel="noopener" style={{ width: '100%' }}>
                        <Button
                            variant="outlined"
                            sx={{
                                width: '100%',
                                fontSize: '16px',
                                color: 'primary.main',
                                bgcolor: '#fff',
                                height: '40px',
                                borderRadius: '100px',
                                border: '2px solid #05668D',
                                fontWeight: 600
                            }}
                        >
                            Log In
                        </Button>
                    </Link>
                </Box>

                {/* <Paper
                sx={{}}
                elevation={3}
            >
                <BottomNavigation
                    sx={{ width: 50 }}
                    value={useLocation().pathname}
                >
                    <BottomNavigationAction
                        component={Link}
                        to="/login"
                        label="Login"
                        value
                    />
                    <BottomNavigationAction />
                </BottomNavigation>
            </Paper> */}
            </Stack>
        </Modal>
    );
};

export default MobileNav;
